
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
                Realizar inscripción
          </h4>
        </template>


        <div class="con-form">
            <h5>Datos de reinscripción</h5>

            <p class="mb-0 text-uppercase"><small>Institución</small></p>
            <p><strong>{{row.institucion}}</strong></p>

            <p class="mb-0 text-uppercase"><small>Ciclo escolar</small></p>
            <p><strong>{{infoPrograma.ciclo_escolar}}</strong></p>

            <p class="mb-0 text-uppercase"><small>Programa</small></p>
            <p><strong>{{row.programa}}</strong></p>

            <p class="mb-0 text-uppercase"><small>Grado</small></p>
            <p><strong>{{infoPrograma.grado}}</strong></p>
        </div>

        <template #footer>
            <div class="con-footer" style="display: flex; justify-content: space-between;">
                <vs-button danger @click="active = false">
                Cancelar
                </vs-button>
                <vs-button success @click="postReinscripcion()">
                Aceptar
                </vs-button>
            </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import landing from '../../../../../api/requests/landing'
    export default {
        props: [
            'value',
            'row',
            'infoPrograma',
            'token',
            'persona_id'
        ],
        data:() => ({
            active: false,
        }),
        methods:{
            async postReinscripcion(){
                    const loading = this.$vs.loading()
                try{
                    const formData  = new FormData();
                    formData.append('programa_id', this.row.programa_id)
                    formData.append('ciclo_escolar_id', this.infoPrograma.ciclo_escolar_id)
                    formData.append('institucion_id', this.row.institucion_id)
                    formData.append('persona_id', this.persona_id)
                    formData.append('tipo_registro', this.infoPrograma.tipo_registro)
                    formData.append('atributo_id', this.infoPrograma.atributo_id)
                    formData.append('status_inscripcion', 'confirmada')
                    const {data: response} = await landing.postReinscripcion(formData)
                    this.active = false
                    loading.close()
                    this.$emit('refreshInfo')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Inscripción éxitosa',
                        text: 'La inscripción se ha realizado con éxito.'
                    })

                }catch{
                    loading.close()
                    this.active = false
                }
            }
        },
        watch: {
            value (val) {
                this.active = val
            },    
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>
